import * as turf from "@turf/turf";
import { getAmapRegeo } from "api/layer";
import china from "assets/json/c1.json";
import countries from "assets/json/country.json";

const chinaGeojson = turf.polygon(china.features[0].geometry.rings);

/**
 * 根据经纬度获取反向地理编码信息
 * @param lng 经度
 * @param lat 纬度
 * @returns 包含国家和地址的对象，或在出错时返回 null
 */
export const reverseGeocode = async (lng: number, lat: number) => {
  try {
    const point = [lng, lat]
    const params = {
      spatial: "gcj",
      location: point.join(","),
      oversea: false
    };
		if (!turf.booleanPointInPolygon(point, chinaGeojson)) {
			params.spatial = "wgs";
			params.oversea = true;
		}

    const res: any = await getAmapRegeo(params);

    if (res && res.status && res.data && res.data.length > 0) {
      // 优先使用中文地址
      const regeoData =
        res.data.find(
          (d: any) => d.regeocode?.addressComponent?.country === "中国"
        ) || res.data[0];

      const { regeocode } = regeoData;
      const countryName = regeocode.addressComponent.country;
      const countryInfo = countries.find(c => c.label === countryName);
      const coordinateSystem = regeoData.spatial === "gcj" ? "gcj02" : "wgs84";
      
      const township = regeocode.addressComponent.township;
      const street = Array.isArray(township) && township.length === 0 ? null : township;
      const district = regeocode.addressComponent.district;
      const county = Array.isArray(district) && district.length === 0 ? null : district;

      return {
        country: countryName,
        city: regeocode.addressComponent.city,
        county,
        address: regeocode.formatted_address,
        location: regeoData.location,
        number: regeocode.addressComponent.streetNumber?.number[0] ?? "",
        province: regeocode.addressComponent.province,
        street,
        oversea: regeoData.oversea,
        coordinateSource: "reGeoEncoded",
        coordinateSystem,
        countryISO3: countryInfo?.iso3 ?? ""
      };
    }
    return null;
  } catch (error) {
    console.error("Reverse geocoding failed:", error);
    return null;
  }
};
